import { render, staticRenderFns } from "./multi-file-choose.vue?vue&type=template&id=58b4cf50&scoped=true&"
import script from "./multi-file-choose.vue?vue&type=script&lang=js&"
export * from "./multi-file-choose.vue?vue&type=script&lang=js&"
import style0 from "./multi-file-choose.vue?vue&type=style&index=0&id=58b4cf50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b4cf50",
  null
  
)

export default component.exports